import $ from 'jquery';
import slick from 'slick-carousel';
import AOS from 'aos';
import validate from 'jquery-validation';
import axios from 'axios';
import 'select2/dist/js/select2.full.js';
import { startStimulusApp } from '@symfony/stimulus-bridge';
import { registerReactControllerComponents } from '@symfony/ux-react';
import ReactController from '@symfony/ux-react/dist/render_controller';

try {
    window.$ = window.jQuery = require('jquery');
    window.$.fn.exists = function() {
        return this.length !== 0;
    };
    window.$.fn.isEmpty = function() {
        return !$.trim(this.html());
    };
} catch (e) {
    console.error(e);
}

window.axios = require('axios');
window.swal = require('sweetalert');

// Start Stimulus application
export const app = startStimulusApp();

// Register the React Stimulus controller
app.register('symfony--ux-react--react', ReactController);

// Register React components for Symfony UX
registerReactControllerComponents(
    require.context('./react/components', true, /\.(j|t)sx?$/)
);

import { accordion } from './accordion';
import { animationsPimcoreSection, animationsSolutionsPage, anchorSmoothScroll, introSectionAnimation } from './animations';
import { carouselClients, carouselServices, carouselSolutions, carouselGallery, carouselGallerySingle, carouselExpertise } from './carousels';
import { headerToggle } from './header';
import { footerPosition } from './footer';
import { navigationMenu } from './navigation';
import { allTestimonials } from './allTestimonials';
import { homepageScroll } from './homepage-scroll';
import { contactUsFormFloatingLabels, contactUsFormValidation } from './contact-us';
import { bookADemoFormValidation } from './book-a-demo';
import { consultationFormValidation } from './consultation';
import { quoteFormSelects, quoteFormValidation } from './quote-form';
import { contactPageShowForm } from './contact-page';
import { ourWorkCursor } from './our-work-cursor';
import { progressIndicator } from './progress-indicator';
import { imageModal } from './image-modal';
import { showContentBlockedByCookies } from './cookies';
import { langSwitch } from './lang-switch';
import { adaptSolutionsSectionToMobile } from "./solutions-section-mobile";
import { codeBrickSelects } from "./code-brick";
import { homepageIntroAnimation } from "./homepage-intro";
import { initCodeSnippets } from "./code-snippet";
import { initSentry } from "./sentry";
import { initSlideinBanner } from "./slidein-banner";
import { initGaEvents } from "./ga";

$(() => {
    initSentry();
    accordion();
    carouselClients();
    carouselServices();
    carouselSolutions();
    carouselGallery();
    carouselGallerySingle();
    carouselExpertise();
    headerToggle();
    footerPosition();
    navigationMenu();
    animationsPimcoreSection();
    allTestimonials();
    animationsSolutionsPage();
    anchorSmoothScroll();
    homepageIntroAnimation();
    homepageScroll();
    contactUsFormFloatingLabels();
    contactUsFormValidation();
    bookADemoFormValidation();
    consultationFormValidation();
    quoteFormSelects();
    contactPageShowForm();
    ourWorkCursor();
    progressIndicator();
    imageModal();
    showContentBlockedByCookies();
    quoteFormValidation();
    langSwitch();
    adaptSolutionsSectionToMobile();
    introSectionAnimation();
    codeBrickSelects();
    initCodeSnippets();
    initSlideinBanner();
    initGaEvents();

    AOS.init({
        once: true,
    });

    // Autoplay video if its in viewport and not already playing
    const videoElement = $('.video-full-block[data-autoplay="true"]:not(.editmode) video');
    if (videoElement.length) {
        document.addEventListener('scroll', () => {
            const videoIsVisible = elementInViewport(videoElement[0]);
            const isVideoPlaying = checkIsVideoPlaying(videoElement[0]);
            
            if (videoIsVisible && !isVideoPlaying) {
                videoElement[0].play();
            }
        });
    }
    
    const $iframes = $('iframe');
    if ($iframes.length) {
        $iframes.each(function () {
            const $iframe = $(this);
            if (!$iframe.parent().hasClass('iframeHolder')) {
                $iframe.wrap('<div class="iframeHolder"></div>');
            }
        });
    }

    const appHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    }
    window.addEventListener('resize', appHeight);
    appHeight();
})

// https://stackoverflow.com/a/125106
function elementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;
  
    while(el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }
  
    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
}

function checkIsVideoPlaying(video) {
    return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2)
}
